import moment from "moment";
import { Booking, Journey, PassengerSegmentValue, Segment } from "@/types/*";
import {
  PRIORITY_BAGGAGE_SSRCODE,
  PRIORITY_BOARDING_SSRCODE,
  MEALS_TITLE,
  EXCESS_BAGGAGE_TITLE,
  PRIORITY_BAGGAGE_TITLE,
  PRIORITY_BOARD_TITLE,
  ERROR_API_NAME,
  SEAT_SELECTION_SSRCODE,
  DEMOSTIC_EXCESS_BAGGAGE_KEY,
  INTERNATION_EXCESS_BAGGAGE_KEY,
  DELAY_COVER_SSRCODE,
  CANCEL_COVER_SSRCODE,
  LOUNGE_SSRCODE,
  FEE_CODES,
  PNR_LEVEL_SSR_CODES,
  TRAVEL_INSURANCE_SSRCODE,
  DELAY_AND_LOST_BAGGAGE_SSRCODE,
  BUNDLE_CODE,
  ALL_BAGGAGE_SSRCODES,
  JOURNEY_LEVEL_SSR_CODES,
  EXCESS_BAGGAGE_CODE,
  MEALS_MEAL_CODE,
  MEAL_BOOKING_HOUR_LIMIT
} from "../../constants/variables/index";
import { deleteSsr, sellSsr, sellTripCover } from "../../dataLayer/AddonAPI";
import { CurrentBookingInState } from "../../dataLayer/CurrentBookingInState";
import { getMealsList, setPlusAddons } from "../../dataLayer/addOnDetails";
import { getFeeCodesPrice } from "../../dataLayer/totalFeeCodes";
import { addDateOfBirth } from "../../dataLayer/updateContact";
import { resetPriceDiff, setCurrentBookingInState } from "../../store/slices/booking";
import { deepCopy } from "../../utils/jsonUtils";
import { errorHandingErrorMessage } from "../errrorHandling/errorHandling";
import { useCommonContext } from "context/CommonDataContext";
import { calculateSegmentDuration } from "helper/duration";
import { isJourneyLevelSsr } from "../passengers";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

export const sellPlusSsrs = (inBundleSsrs: any, passengers: any[]) => {
  if (inBundleSsrs) {
    for (const key in inBundleSsrs) {
      passengers.forEach((passenger: any, passengerIndex: string | number) => {
        if (inBundleSsrs[key]?.[passengerIndex]) {
          Object.values(inBundleSsrs[key]?.[passengerIndex]).forEach((value) => {
            const { ssrKey, ssrCode } = value;
              if (ssrKey && ssrCode !== BUNDLE_CODE.PLUS) {
                setPlusAddons(ssrKey);
              }
          });
        }
      });
    }
  }
};

export const checkForSsrDisabled = (
  ssrCode: string,
  hourLeftForDeparture: number,
  currentBookinginState?: {
    recordLocator?: string | null;
  }
): boolean => {
  let response = true;
  if (ssrCode === DELAY_COVER_SSRCODE) {
    if (hourLeftForDeparture <= 12) {
      response = false;
    }
  } else if (ssrCode === CANCEL_COVER_SSRCODE) {
    if (hourLeftForDeparture <= 36 || currentBookinginState?.recordLocator != null) {
      response = false;
    }
  }
  return response;
};
interface Passenger {
  name: {
    first: string;
    last: string;
  };
  key: string;
}

export const getPaxInfoWithKey = (currentBookinginState: {
  passengers: Array<{
    value: Passenger;
    key: string;
  }>;
}): Passenger[] => {
  try {
    const userDetails: Passenger[] | { name: string; key: string }[] = [];
    currentBookinginState?.passengers.forEach((passenger) => {
      const obj: { name: string; key: string } = {
        name: `${passenger.value.name.first} ${passenger.value.name.last}`,
        key: passenger.key
      };

      userDetails.push(obj);
    });
    return userDetails;
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const excessBagObject = (
  segmentDetails: string | any[],
  destination: any[],
  passenger: string | any[] | null,
  currentBookinginState = null,
  isChangeBooking: boolean = false,
  previouslyBroughtSsrs = null
) => {
  if (passenger == null && currentBookinginState != null) {
    passenger = getPaxInfoWithKey(currentBookinginState);
  }

  const excessBaggageKeys = [
    { ssrCode: "XC03", name: "3  Kgs", display: true, unit: 3 },
    { ssrCode: "XC05", name: "5 Kgs", display: true, unit: 5 },
    { ssrCode: "XC10", name: "10 Kgs", display: true, unit: 10 },
    { ssrCode: "XC15", name: "15 Kgs", display: true, unit: 15 },
    { ssrCode: "XC20", name: "20 Kgs", display: true, unit: 20 },
    { ssrCode: "XC30", name: "30kg", display: true, unit: 30 }
  ];
  const internationExcessBaggageKeys = [
    { ssrCode: "IN08", name: "8  Kgs", display: true, unit: 8 },
    { ssrCode: "IN10", name: "10 Kgs", display: true, unit: 10 },
    { ssrCode: "IN15", name: "15 Kgs", display: true, unit: 15 },
    { ssrCode: "IN30", name: "30kg", display: true, unit: 30 }
  ];
  const extraBaggageKeys = [
    { ssrCode: "ABAG", display: true, name: "1 Bag" },
    { ssrCode: "2BAG", display: true, name: "2 Bags" }
  ];
  const musicKitKeys = [
    { ssrCode: "1KIT", display: true, name: "1 Kit" },
    { ssrCode: "2KIT", display: true, name: "2 Kits" }
  ];
  let fare = 0;
  const updatedSsrList = {};
  const listOfExcessBagTag = {};
  const excessBagTagsArray = [];
  let previousSelection = localStorage.getItem("baggageSsr");
  const selectedSegmentInfo = JSON.parse(localStorage.getItem("segmentDetails") as string);
  if (previousSelection !== "undefined") {
    if (previousSelection) previousSelection = JSON.parse(previousSelection);
    let i = 0;
    for (let segInd = 0; segInd < segmentDetails.length; segInd += 1) {
      const checkForDestinationKeyExist = destination.filter(
        (odsKeys: { key: any }) => segmentDetails[segInd].journeyKey === odsKeys.key
      );

      if (checkForDestinationKeyExist.length === 0) {
        continue;
      }
      if (selectedSegmentInfo && selectedSegmentInfo.length > 0) {
        const checkIfSelectedJourney = selectedSegmentInfo.filter(
          (seg: { key: any }) => segmentDetails[segInd]?.journeyKey === seg.journeyKey
        );
        if (checkIfSelectedJourney.length === 0) {
          continue;
        }
      }
      excessBagTagsArray[i] = {};
      if (!updatedSsrList[segmentDetails[segInd].journeyKey]) updatedSsrList[segmentDetails[segInd].journeyKey] = {};
      updatedSsrList[segmentDetails[segInd].journeyKey].journeyKey = segmentDetails[segInd].journeyKey;
      let tempExcessBaggage = [];
      const tempExtraBaggage = [];
      const tempMusicKit = [];
      if (!updatedSsrList[segmentDetails[segInd].journeyKey].excessBaggage) {
        updatedSsrList[segmentDetails[segInd].journeyKey].excessBaggage = {};
        updatedSsrList[segmentDetails[segInd].journeyKey].excessBaggage.domestic = [];
      }
      for (let j = 0; j < excessBaggageKeys.length; j += 1) {
        const selectedSsr = segmentDetails[segInd].ssrs.filter(
          (a: { ssrCode: string }) => a.ssrCode === excessBaggageKeys[j].ssrCode
        )[0];
        const obj = JSON.parse(JSON.stringify(excessBaggageKeys[j]));
        obj.price = {};
        if (!selectedSsr) {
          obj.display = false;
        }
        for (let p = 0; p < selectedSsr?.passengersAvailability?.length; p += 1) {
          let previousCheck = [];
          if (previousSelection)
            previousCheck = previousSelection.filter(
              (t: { ssrCode: string; passengerKey: any }) =>
                t.ssrCode === excessBaggageKeys[j].ssrCode &&
                t.passengerKey === selectedSsr?.passengersAvailability[p].key
            );
          if (previousCheck?.length) fare += selectedSsr?.passengersAvailability[p]?.value?.price ?? 0;
          if (!obj.price[selectedSsr?.passengersAvailability[p].key])
            obj.price[selectedSsr?.passengersAvailability[p].key] = {
              price: selectedSsr?.passengersAvailability[p].value.price,
              ssrKey: selectedSsr?.passengersAvailability[p].value.ssrKey,
              count: previousCheck?.length ? previousCheck[0].count : 0
            };
        }

        updatedSsrList[segmentDetails[segInd].journeyKey].excessBaggage.domestic.push(obj);
        tempExcessBaggage.push(obj);
        // if(listOfExcessBagTag["excessBaggage"]){
        // listOfExcessBagTag["excessBaggage"] = [];
        // }
        // listOfExcessBagTag["excessBaggage"].push(obj);
      }
      if (!listOfExcessBagTag.excessBaggage) {
        listOfExcessBagTag.excessBaggage = {};
      }
      listOfExcessBagTag.excessBaggage.domestic = tempExcessBaggage;
      if (!excessBagTagsArray[i].excessBaggage) {
        excessBagTagsArray[i].excessBaggage = {};
      }
      excessBagTagsArray[i].excessBaggage.domestic = tempExcessBaggage;

      // internation bag :
      tempExcessBaggage = [];
      if (!updatedSsrList[segmentDetails[segInd].journeyKey].excessBaggage)
        updatedSsrList[segmentDetails[segInd].journeyKey].excessBaggage = [];
      for (let j = 0; j < internationExcessBaggageKeys.length; j += 1) {
        const selectedSsr = segmentDetails[segInd].ssrs.filter(
          (a: { ssrCode: string }) => a.ssrCode === internationExcessBaggageKeys[j].ssrCode
        )[0];
        const obj = JSON.parse(JSON.stringify(internationExcessBaggageKeys[j]));
        obj.price = {};
        if (!selectedSsr) {
          obj.display = false;
        }
        for (let p = 0; p < selectedSsr?.passengersAvailability?.length; p += 1) {
          let previousCheck = [];
          if (previousSelection)
            previousCheck = previousSelection.filter(
              (t: { ssrCode: string; passengerKey: any }) =>
                t.ssrCode === internationExcessBaggageKeys[j].ssrCode &&
                t.passengerKey === selectedSsr?.passengersAvailability[p].key
            );
          if (previousCheck?.length) fare += selectedSsr?.passengersAvailability[p]?.value?.price ?? 0;
          if (!obj.price[selectedSsr?.passengersAvailability[p].key])
            obj.price[selectedSsr?.passengersAvailability[p].key] = {
              price: selectedSsr?.passengersAvailability[p].value.price,
              ssrKey: selectedSsr?.passengersAvailability[p].value.ssrKey,
              count: previousCheck?.length ? previousCheck[0].count : 0
            };
        }
        if (!updatedSsrList[segmentDetails[segInd].journeyKey].excessBaggage.international) {
          updatedSsrList[segmentDetails[segInd].journeyKey].excessBaggage.international = [];
        }
        updatedSsrList[segmentDetails[segInd].journeyKey].excessBaggage.international.push(obj);
        tempExcessBaggage.push(obj);
        // if(listOfExcessBagTag["excessBaggage"]){
        // listOfExcessBagTag["excessBaggage"] = [];
        // }
        // listOfExcessBagTag["excessBaggage"].push(obj);
      }
      listOfExcessBagTag.excessBaggage.international = tempExcessBaggage;
      excessBagTagsArray[i].excessBaggage.international = tempExcessBaggage;

      if (!updatedSsrList[segmentDetails[segInd].journeyKey].extraBaggage)
        updatedSsrList[segmentDetails[segInd].journeyKey].extraBaggage = [];
      for (let j = 0; j < extraBaggageKeys.length; j += 1) {
        const selectedSsr = segmentDetails[segInd].ssrs.filter(
          (a: { ssrCode: string }) => a.ssrCode === extraBaggageKeys[j].ssrCode
        )[0];
        const obj = JSON.parse(JSON.stringify(extraBaggageKeys[j]));
        obj.price = {};
        if (!selectedSsr) {
          obj.display = false;
        }
        for (let p = 0; p < selectedSsr?.passengersAvailability.length; p += 1) {
          let previousCheck = [];
          if (previousSelection)
            previousCheck = previousSelection.filter(
              (t: { ssrCode: string; passengerKey: any }) =>
                t.ssrCode === extraBaggageKeys[j].ssrCode &&
                t.passengerKey === selectedSsr?.passengersAvailability[p].key
            );
          if (previousCheck?.length) fare += selectedSsr?.passengersAvailability[p].value.price ?? 0;
          if (!obj.price[selectedSsr?.passengersAvailability[p].key])
            obj.price[selectedSsr?.passengersAvailability[p].key] = {
              price: selectedSsr?.passengersAvailability[p].value.price,
              ssrKey: selectedSsr?.passengersAvailability[p].value.ssrKey,
              count: previousCheck?.length ? previousCheck[0].count : 0
            };
        }

        updatedSsrList[segmentDetails[segInd].journeyKey].extraBaggage.push(obj);
        // if(!listOfExcessBagTag["extraBaggage"]){
        //   listOfExcessBagTag["extraBaggage"] = [];
        // }
        tempExtraBaggage.push(obj);
      }
      listOfExcessBagTag.extraBaggage = tempExtraBaggage;
      excessBagTagsArray[i].extraBaggage = tempExtraBaggage;

      if (!updatedSsrList[segmentDetails[segInd].journeyKey].musicKit)
        updatedSsrList[segmentDetails[segInd].journeyKey].musicKit = [];
      for (let j = 0; j < musicKitKeys.length; j += 1) {
        const selectedSsr = segmentDetails[segInd].ssrs.filter(
          (a: { ssrCode: string }) => a.ssrCode === musicKitKeys[j].ssrCode
        )[0];
        const obj = JSON.parse(JSON.stringify(musicKitKeys[j]));
        obj.price = {};
        if (!selectedSsr) {
          obj.display = false;
        }

        for (let p = 0; p < selectedSsr.passengersAvailability.length; p += 1) {
          let previousCheck = [];
          if (previousSelection)
            previousCheck = previousSelection.filter(
              (t: { ssrCode: string; passengerKey: any }) =>
                t.ssrCode === extraBaggageKeys[j].ssrCode &&
                t.passengerKey === selectedSsr.passengersAvailability[p].key
            );
          if (previousCheck?.length) fare += selectedSsr.passengersAvailability[p].value.price;
          if (!obj.price[selectedSsr.passengersAvailability[p].key])
            obj.price[selectedSsr.passengersAvailability[p].key] = {
              price: selectedSsr.passengersAvailability[p].value.price,
              ssrKey: selectedSsr.passengersAvailability[p].value.ssrKey,
              count: previousCheck?.length ? previousCheck[0].count : 0
            };
        }
        // if(!listOfExcessBagTag["musicKit"]){
        //   listOfExcessBagTag["musicKit"] = [];
        // }
        updatedSsrList[segmentDetails[segInd].journeyKey].musicKit.push(obj);
        tempMusicKit.push(obj);
      }
      listOfExcessBagTag.musicKit = tempMusicKit;
      excessBagTagsArray[i].musicKit = tempMusicKit;
      i += 1;
    }

    // setFare(fare)
    // setBaggages({...updatedSsrList})
  }
  for (let passengerInfoIndex = 0; passengerInfoIndex < passenger?.length; passengerInfoIndex += 1) {
    passenger[passengerInfoIndex].isActive = passengerInfoIndex === 0; // make active default for the first pax
    passenger[passengerInfoIndex].fareTotal = 0;
    passenger[passengerInfoIndex].ssrCount = 0;
    passenger[passengerInfoIndex].excessBaggage = excessBagTagsArray;
  }
  let journey = [];

  if (destination) {
    for (let index = 0; index < destination.length; index += 1) {
      destination[index].isActive = index === 0; // make first as default actvie
      destination[index].passengerInfo = passenger;
      const dateOfJourneyDeparture = moment.duration(moment(destination[index]?.arrival).diff(moment.now())).asHours();
      let shouldAddIntoJourney = false;
      if (dateOfJourneyDeparture > 0) {
        shouldAddIntoJourney = true;
      }
      if (shouldAddIntoJourney && selectedSegmentInfo && selectedSegmentInfo.length > 0) {
        const checkForLeg = selectedSegmentInfo.filter(
          (seg: { key: any }) => destination[index]?.key === seg.journeyKey
        );
        if (checkForLeg.length === 0) {
          shouldAddIntoJourney = false;
        }
      }
      if (shouldAddIntoJourney) {
        journey.push(destination[index]);
      }
    }
  }
      
    if (isChangeBooking && previouslyBroughtSsrs !== null) {
      journey = journey.map((journeyObj: any, index: any) => {
        currentBookinginState.journeys.forEach(journey => {
          const segmentObj = journey.segments.find(segment => journeyObj.segmentKeys.includes(segment?.segmentKey))
          if (segmentObj) {
            segmentObj.passengerSegment.forEach(pax => {
              const tempExcessBaggage = pax.ssrs.filter(ssr => ALL_BAGGAGE_SSRCODES.includes(ssr.ssrCode));
              if (tempExcessBaggage.length > 0) {
                const passengerInfo = journeyObj?.passengerInfo.map((paxInfo: any) => {
                  let domestic = []
                  let international = []
                  let extraBaggage = []
                  let musicKit = []
                  if (paxInfo.excessBaggage.length > 0) {
                    domestic = paxInfo.excessBaggage[index]?.excessBaggage?.domestic?.map((baggage: any) => {
                      const found = tempExcessBaggage.find(tempBaggage => tempBaggage.ssrCode === baggage.ssrCode && 
                      paxInfo.key === tempBaggage.passengerKey)
                      if (found) {             
                        return {
                          ...baggage,
                          isActive: true,  
                          journeyKey: journeyObj.key
                        }
                      }
                      return baggage
                    })

                    international = paxInfo.excessBaggage[index]?.excessBaggage?.international?.map((baggage: any) => {
                      const found = tempExcessBaggage.find(tempBaggage => tempBaggage.ssrCode === baggage.ssrCode && 
                        paxInfo.key === tempBaggage.passengerKey)
                      if (found) {             
                        return {
                          ...baggage,
                          isActive: true,
                        }
                      }
                      return baggage
                    })

                    extraBaggage =  paxInfo.excessBaggage[index]?.extraBaggage?.map((baggage: any) => {
                      const found = tempExcessBaggage.find(tempBaggage => tempBaggage.ssrCode === baggage.ssrCode && 
                        paxInfo.key === tempBaggage.passengerKey)
                      if (found) {             
                        return {
                          ...baggage,
                          isActive: true,
                        }
                      }
                      return baggage
                    })

                    musicKit =  paxInfo.excessBaggage[index]?.musicKit?.map((baggage: any) => {
                      const found = tempExcessBaggage.find(tempBaggage => tempBaggage.ssrCode === baggage.ssrCode && 
                        paxInfo.key === tempBaggage.passengerKey)
                      if (found) {             
                        return {
                          ...baggage,
                          isActive: true,
                        }
                      }
                      return baggage
                    })

                    const updatedPaxInfo = deepCopy(paxInfo)
                    updatedPaxInfo.excessBaggage[index].excessBaggage.domestic = domestic
                    updatedPaxInfo.excessBaggage[index].excessBaggage.international = international
                    updatedPaxInfo.excessBaggage[index].extraBaggage = extraBaggage  
                    updatedPaxInfo.excessBaggage[index].musicKit =  musicKit
                    return updatedPaxInfo
                  }
                  return paxInfo
                })
                journeyObj.passengerInfo = passengerInfo
              }
            });
          }
        });
        return journeyObj
      })
    }
  return journey;
};

export async function sellExcessBag(selectedSsrList: {
  [x: string]: { [x: string]: { [x: string]: { ssrKey: any } } };
}, isChangeBooking: boolean) {
  try {
    const ssrList: { ssrKey: any; count: number }[] = [];
    const alreadySoldSsrList: { ssrKey: any; count: number }[] = [];
    // let clearPreviousExcessBag = await deleteExcessBag();
    const masterSsrList: { ssrKey: any; count: number }[] = [];
    const previousSelection = JSON.parse(localStorage.getItem("baggageSsr"));    
    Object.keys(selectedSsrList).forEach((journeyKey) => {
      Object.keys(selectedSsrList[journeyKey]).forEach((paxKey) => {
        Object.keys(selectedSsrList[journeyKey][paxKey]).forEach((key) => {
          // console.warn(previousSelection.filter( previousSsr => (previousSsr.ssrKey == selectedSsrList[journeyKey][paxKey][key].ssrKey)));
            if (ALL_BAGGAGE_SSRCODES.includes(key)) {
              if (
                previousSelection &&
                previousSelection.filter(
                  (previousSsr: { ssrKey: any }) => previousSsr.ssrKey === selectedSsrList[journeyKey][paxKey][key].ssrKey
                ).length > 0
              ) {
                alreadySoldSsrList.push({
                  ssrKey: selectedSsrList[journeyKey][paxKey][key].ssrKey,
                  count: 1
                });
                // if the ssr is already sold, dont sell next time.
                // console.warn("skip as it already added")
              } else {
                ssrList.push({
                  ssrKey: selectedSsrList[journeyKey][paxKey][key].ssrKey,
                  count: 1
                });
              }
              masterSsrList.push({
                ssrKey: selectedSsrList[journeyKey][paxKey][key].ssrKey,
                count: 1
              });
            }
        });
      });
    });
    // // unsell the previous or non-matching ssr list
    const unsellSsrList = [];
    if (previousSelection) {
      for (let ind = 0; ind < previousSelection.length; ind += 1) {
        const checkExist = masterSsrList.filter((addedSsr) => addedSsr.ssrKey === previousSelection[ind].ssrKey);
        if (checkExist.length === 0) {
          unsellSsrList.push(previousSelection[ind].ssrKey);
        }
      }
    }
    let response;
    if (unsellSsrList?.length) {
      response = await deleteSsr(unsellSsrList);
    }

    if (ssrList.length === 0 && alreadySoldSsrList.length === 0 ) {
      // delete all ssr :
      localStorage.removeItem("baggageSsr");
      localStorage.removeItem("baggageFare");
    } else if (masterSsrList.length > 0) {
      localStorage.setItem("baggageSsr", JSON.stringify(masterSsrList));
    }

    if (ssrList.length > 0) {
      response = await sellSsr(ssrList);
    }

    if (!response) {
      response = true; // delete all the ssr,
    }
    return response;
  } catch (error) {
    console.warn(error);
    return errorHandingErrorMessage(ERROR_API_NAME.SSR_SELL_API, error);
  }
}

export const ssrKeyList = (objectOfSsr: {
  [journeyIndex: string]: {
    [paxKey: string]: {
      [key: string]: {
        ssrKey: any;
      };
    };
  };
}) => {
  const arrayList: any[] = [];

  Object.values(objectOfSsr).forEach((journey) => {
    Object.values(journey).forEach((pax) => {
      Object.values(pax).forEach((ssr) => {
        arrayList.push(ssr.ssrKey);
      });
    });
  });

  return arrayList;
};

export const adhosType = (ssrCodeArry) => {

  let response = {
        code: 200,
        status: true,
        data: {}
      };

  const ssrCodeType = {
    isBoarding: false,
    BoardingCount: 0,
    BoardingPrice: 0,
 
    isExcessBag: false,
    ExcessBagCount: 0,
    ExcessBagPrice: 0,
 
    isMeal: false,
    MealCount: 0,
    MealPrice: 0,
 
    isPriorityBaggage: false,
    PriorityBaggageCount: 0,
    PriorityBaggagePrice: 0,
 
    isSeatSelected: false,
    SeatSelectedCount: 0,
    SeatSelectedPrice: 0,
 
    isDelayCover: false,
    DelayCoverPrice: 0,
    DelayCoverCount: 0,
 
    isLounge: false,
    LoungePrice: 0,
    LoungeCount: 0,
 
    isTravelInsurance: false,
    TravelInsurancePrice: 0,
 
    TravelInsuranceCount: 0,
 
    isDelayAndLostBaggage: false,
    DelayAndLostBaggagePrice: 0,
    DelayAndLostBaggageCount: 0,
 
    totalAddonsCount: 0,
    totalAmount: 0
  };
 
  Object.entries(ssrCodeArry).forEach(([ssrCode, ssrDetails]) => {
    const count = ssrDetails.count || 0;
    const amount = ssrDetails.totalAmount|| 0;
    const totalAmount = amount * count;
 
    switch (ssrCode) {
      case "SFE": // SEAT_SELECTION_SSRCODE
        ssrCodeType.isSeatSelected = true;
        ssrCodeType.SeatSelectedPrice += totalAmount;
        ssrCodeType.SeatSelectedCount += count;
        break;
      case "PRIO": // PRIORITY_BAGGAGE_SSRCODE
        ssrCodeType.isPriorityBaggage = true;
        ssrCodeType.PriorityBaggagePrice += totalAmount;
        ssrCodeType.PriorityBaggageCount += count;
        break;
      case "PRBD": // PRIORITY_BOARDING_SSRCODE
        ssrCodeType.isBoarding = true;
        ssrCodeType.BoardingPrice += totalAmount;
        ssrCodeType.BoardingCount += count;
        break;
      case "FLDL": // DELAY_COVER_SSRCODE
        ssrCodeType.isDelayCover = true;
        ssrCodeType.DelayCoverPrice += totalAmount;
        ssrCodeType.DelayCoverCount += count;
        break;
 
      case "ALNG": // LOUNGE_SSRCODE
        ssrCodeType.isLounge = true;
        ssrCodeType.LoungePrice += totalAmount;
        ssrCodeType.LoungeCount += count;
        break;
 
      case "INSU": // TRAVEL_INSURANCE_SSRCODE
        ssrCodeType.isTravelInsurance = true;
        ssrCodeType.TravelInsurancePrice += totalAmount;
        ssrCodeType.TravelInsuranceCount += count;
        break;
 
      case "DLBG": // DELAY_AND_LOST_BAGGAGE_SSRCODE
        ssrCodeType.isDelayAndLostBaggage = true;
        ssrCodeType.DelayAndLostBaggagePrice += totalAmount;
        ssrCodeType.DelayAndLostBaggageCount += count;
        break;
 
      default:
        if (ssrCode.startsWith("XC")) {
          ssrCodeType.isExcessBag = true;
          ssrCodeType.ExcessBagPrice += totalAmount;
          ssrCodeType.ExcessBagCount += count;
        } else {
          ssrCodeType.isMeal = true;
          ssrCodeType.MealPrice += totalAmount;
          ssrCodeType.MealCount += count;
        }
    }
 
    // Update the total amounts and counts
    ssrCodeType.totalAmount += totalAmount;
    ssrCodeType.totalAddonsCount += count;
  });
 
  response = {
        code: 200,
        status: true,
        data: ssrCodeType
      };

  return response    
};

export const adhosName = (ssrCode: string) => {
  try {
    if (ssrCode) {
      const ssrCodeType = {
        isPriorityBaggage: false,
        isMeal: false,
        isBoarding: false,
        isExcessBag: false,
        totalAmount: 0,
        totalAddonsCount: 0
      };
      if (ssrCode === PRIORITY_BAGGAGE_SSRCODE) {
        ssrCodeType.isPriorityBaggage = true;
      } else if (ssrCode === PRIORITY_BOARDING_SSRCODE) {
        ssrCodeType.isBoarding = true;
      } else if (ssrCode.substring(0, 2) === "XC") {
        ssrCodeType.isExcessBag = true;
      } else {
        ssrCodeType.isMeal = true;
      }

      if (ssrCodeType.isMeal) {
        return MEALS_TITLE;
      }
      if (ssrCodeType.isExcessBag) {
        return EXCESS_BAGGAGE_TITLE;
      }
      if (ssrCodeType.isPriorityBaggage) {
        return PRIORITY_BAGGAGE_TITLE;
      }
      if (ssrCodeType.isBoarding) {
        return PRIORITY_BOARD_TITLE;
      }
    } else {
      return "";
    }
  } catch (error) {
    console.warn(error);
  }
};

export async function deleteSsrAllBagsFromLocalStore() {
  try {
    const baggageSsr = JSON.parse(localStorage.getItem("baggageSsr"));

    const ssrKeyListArray = [];
    if (baggageSsr && baggageSsr.length > 0) {
      for (let tempind = 0; tempind < baggageSsr.length; tempind += 1) {
        ssrKeyListArray.push(baggageSsr[tempind].ssrKey);
      }

      const perChunk = 4;
      const result = ssrKeyListArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);
        return resultArray;
      }, []);

      let data;
      for (let ind = 0; ind < result.length; ind += 1) {
        data = await deleteSsr(result[ind]);
      }
      if (data) {
        localStorage.removeItem("baggageSsr");
        localStorage.removeItem("baggageFare");
      }
    }
  } catch (error) {
    console.warn(error);
  }
}

export const getJourneyLevelDetails = (
  currentBookinginStateAsParameter: any,
  selectedSegment = null,
  ssrCode: string | null = null,
  ssrList = {}
) => {
  try {
    const journeyDetails: { isDisplay: boolean; org: any; dest: any; key: any; arrival: any; legKeys: never[] }[] = [];
    let currentBookinginState = currentBookinginStateAsParameter;
    if (currentBookinginState.data) {
      currentBookinginState = currentBookinginStateAsParameter;
    }
    // TO-DO: pulling journey details from first journey as of now - find logic for multiple journey in a trip
    if (currentBookinginState && currentBookinginState.journeys) {
      currentBookinginState.journeys.forEach(
        (
          journey: {
            designator: { origin: any; destination: any; arrival: any; departure: moment.MomentInput };
            journeyKey: any;
            segments: any[];
          },
          index: any
        ) => {
          const journeyObj = {
            org: journey.designator.origin,
            dest: journey.designator.destination,
            key: journey.journeyKey,
            arrival: journey.designator.arrival,
            legKeys: [],
            segmentKeys: journey.segments.map(segment => segment.segmentKey)
          };
          let openSegFlag = true;
          let checkForLeg = [];
          if (selectedSegment) {
            checkForLeg = selectedSegment.filter((seg: { key: any }) =>
              journey.segments.some((segment: { segmentKey: any }) => segment.segmentKey === seg.key)
            );

            if (checkForLeg.length === 0) {
              openSegFlag = false;
            }
          }

          if (openSegFlag) {
            // check weather that journey is allow or not
            const hourLeftForDeparture = moment
              .duration(moment(journey.designator?.departure).diff(moment.now()))
              .asHours();
            openSegFlag = checkForSsrDisabled(ssrCode, hourLeftForDeparture, currentBookinginState);
          }

          if (openSegFlag && Object.keys(ssrList).length > 0) {
            if (ssrCode === LOUNGE_SSRCODE || ssrCode === CANCEL_COVER_SSRCODE) {
              const [firstKey] = Object.keys(ssrList).filter((key) => ssrList[key].key === journeyObj.key);
              if (firstKey && ssrList[firstKey]?.ssrs?.ssrCode !== ssrCode) {
                openSegFlag = false;
              }
              if (!firstKey) {
                // if firstKey is not there, set to false
                openSegFlag = false;
              }
            }
          }
          const dateOfJourneyDeparture = moment
            .duration(moment(journey.designator?.departure).diff(moment.now()))
            .asHours();
          if (dateOfJourneyDeparture < 0) {
            openSegFlag = false; // flight is already takeoff
          }
          journeyDetails.push({ ...journeyObj, isDisplay: openSegFlag });
        }
      );
    }
    return journeyDetails;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getSegmentLevelDetails = (
  currentBookinginState: { journeys: any[] },
  selectedSegment = null,
  ssrCode = "",
  ssrList = {}
): {
  org: any;
  dest: any;
  key: any;
  arrival: any;
  journeyKey: any;
  legKeys: any;
  displayStatus: boolean;
}[] => {
  const segmentDetails: {
    org: any;
    dest: any;
    key: any;
    arrival: any;
    journeyKey: any;
    legKeys: any;
    displayStatus: boolean;
  }[] = [];
  // TO-DO: pulling journey details from first journey as of now - find logic for multiple journey in a trip
  currentBookinginState?.journeys?.forEach((journey: { segments: any[]; journeyKey: any }) => {
    journey.segments.forEach((segment: {
        designator: {
          origin: any;
          destination: any;
          arrival: any;
          departure: any;
        };
        segmentKey: any;
        passengerSegment: any;
        identifier: any;
        LegDetails: any;
        isAnyCheckedIn: any;
        legs: { legKey: any }[];
      }) => {
        if (segment.passengerSegment) {
          const checkedInData = segment.passengerSegment.filter(
            (paxInfo: { liftStatus: string }) => paxInfo?.liftStatus === "CheckedIn" || paxInfo?.liftStatus === "Boarded"
          );
          const segObj = {
            org: segment.designator.origin,
            dest: segment.designator.destination,
            key: segment.segmentKey,
            arrival: segment.designator.arrival,
            departure: segment.designator.departure,
            journeyKey: journey.journeyKey,
            legKeys: [segment?.legs?.[0]?.legKey],
            passengerSegment: segment.passengerSegment,
            identifier: segment.identifier,
            LegDetails: segment.legs,
            isAnyCheckedIn: checkedInData.length !== 0
          };

          let openSegFlag = true;
          let checkForLeg = [];
          if (selectedSegment) {
            checkForLeg = selectedSegment.filter((seg: { key: any }) => seg.key === segment.segmentKey);
            if (checkForLeg.length === 0) {
              openSegFlag = false;
            }
          }
          if (openSegFlag) {
            // check weather that journey is allow or not
            const hourLeftForDeparture = moment
              .duration(moment(journey.designator?.departure).diff(moment.now()))
              .asHours();
            openSegFlag = checkForSsrDisabled(ssrCode, hourLeftForDeparture, currentBookinginState);
          }
          if (openSegFlag && Object.keys(ssrList).length > 0) {
            if (ssrCode === LOUNGE_SSRCODE) {
              const ssrListOfSearchResult = Object.fromEntries(
                Object.entries(ssrList).filter(([key, value]) => value.key === segObj.key)
              );
              const firstKey = Object.keys(ssrListOfSearchResult)[0];

              if (ssrListOfSearchResult?.[firstKey]?.ssrs?.ssrCode !== LOUNGE_SSRCODE) {
                openSegFlag = false;
              }
            }
          }
          const dateOfJourneyDeparture = moment
            .duration(moment(journey.designator?.departure).diff(moment.now()))
            .asHours();
          if (dateOfJourneyDeparture < 0) {
            openSegFlag = false; // flight is already takeoff
          }

          segmentDetails.push({ ...segObj, displayStatus: openSegFlag, isDisplay: openSegFlag });
        }
      }
    );
  });

  return segmentDetails;
};

export const getSegmentLevelDetailsForComplimentaryMeal = (
  currentBookinginState: { journeys: any[] },
  selectedSegmentDetails = null,
  inBundleSsrs = null
) => {
  const segmentDetails: {
    org: any;
    dest: any;
    key: any;
    arrival: any;
    legKeys: never[];
    showSegement: boolean;
    index: number;
    activeIndexNumber: number;
    journeyKey: string;
  }[] = [];
  let trackInd = -1;

  if (currentBookinginState && currentBookinginState.journeys) {
    currentBookinginState.journeys.forEach((journey: { segments: any[] }) => {
      let longestSegmentIndex = -1;
      let longestDuration = -1;

      journey.segments.map((segment: { legs: any[] }, index: number) => {
        const selectedSeg = selectedSegmentDetails?.find((seg) => seg.key === segment.segmentKey);
        if (selectedSeg && inBundleSsrs[journey.journeyKey]) {
          trackInd += 1;

          // Calculate the duration of each segment and save keep track of longest duration segment in journey 
          // and also its segment index. We use the index to mark that segment to be shown active for free meal.
          const duration = calculateSegmentDuration(segment).asSeconds();
          if(duration > longestDuration) {
            longestDuration = duration;
            longestSegmentIndex = trackInd;
          }

          // Push all the segments into segmentDetails. showSegement is marked as false by default now. to disable 
          // all segments on the UI. Below we find the longest segment and just mark that as eligible for selection.
          segmentDetails.push({
            org: segment.designator.origin,
            dest: segment.designator.destination,
            key: segment.segmentKey,
            arrival: segment.designator.arrival,
            legKeys: [segment?.legs[0]?.legKey],
            showSegement: false,
            index: trackInd,
            activeIndexNumber: index,
            journeyKey: journey.journeyKey
          });
        }
      });

      if(longestSegmentIndex > -1) {
        // Activate only the longest segment in each journey
        segmentDetails[longestSegmentIndex].showSegement = true;
      }

    });
  }

  return segmentDetails;
};
/*
from currentbooking in state, check wheather, user have already buy nation or internal bag type

*/
export const checkForExcessBag = (currentBookinginState: { fees: string | any[] }) => {
  try {
    const response = {
      status: true,
      data: {}
    };
    const tempData = {};
    let isNoExcessBagBuy = true;
    let isDemesticBagBuy = false;
    let isInternationExcessBagBuy = false;
    if (currentBookinginState.fees) {
      for (let paxInd = 0; paxInd < currentBookinginState.fees.length; paxInd += 1) {
        const paxSsrs = currentBookinginState.fees[paxInd];
        tempData[paxSsrs.passengerKey] = {
          isDomesticExcessBag: false,
          isInternationExcessBag: false,
          isNoExcessBag: true
        };
        const allSsrs = paxSsrs?.value;
        for (let ssrInd = 0; ssrInd < allSsrs.length; ssrInd += 1) {
          const currentSsr = allSsrs[ssrInd];

          if (DEMOSTIC_EXCESS_BAGGAGE_KEY.includes(currentSsr.code)) {
            tempData[paxSsrs.passengerKey].isDomesticExcessBag = true;
            tempData[paxSsrs.passengerKey].isNoExcessBag = false;
            if (isNoExcessBagBuy) {
              isNoExcessBagBuy = false;
            }
            if (!isDemesticBagBuy) {
              isDemesticBagBuy = true;
            }
          }
          if (INTERNATION_EXCESS_BAGGAGE_KEY.includes(currentSsr.code)) {
            tempData[paxSsrs.passengerKey].isInternationExcessBag = true;
            tempData[paxSsrs.passengerKey].isNoExcessBag = false;
            if (isNoExcessBagBuy) {
              isNoExcessBagBuy = false;
            }
            if (!isInternationExcessBagBuy) {
              isInternationExcessBagBuy = true;
            }
          }
        }
      }
    }

    response.data = {
      passenger: tempData,
      isNoExcessBagBuy,
      isDemesticBagBuy,
      isInternationExcessBagBuy
    };
    return response;
  } catch (error) {
    console.error(error);
    const response = {
      status: false
    };
    return response;
  }
};

/*
from currentbooking in state, check wheather, user have already buy nation or internal bag type

*/
export const checkForExcessBagV2 = (currentBookinginState: { journeys: any[] }) => {
  try {
    const response = {
      status: true,
      data: {}
    };
    const tempData = {};
    let isNoExcessBagBuy = true;
    let isDemesticBagBuy = false;
    let isInternationExcessBagBuy = false;
    const journeylevel = {};
    if (currentBookinginState.journeys) {
      for (let journeyInd = 0; journeyInd < currentBookinginState.journeys.length; journeyInd += 1) {
        journeylevel[journeyInd] = {
          isDomesticExcessBag: false,
          isInternationExcessBag: false,
          isNoExcessBag: true
        };
        isNoExcessBagBuy = true;
        isDemesticBagBuy = false;
        isInternationExcessBagBuy = false;
        const journeyInfo = currentBookinginState.journeys[journeyInd];
        const paxInfo = journeyInfo?.segments[0]?.passengerSegment;
        if (!tempData[journeyInd]) {
          tempData[journeyInd] = {};
        }

        for (let paxIndex = 0; paxIndex < paxInfo.length; paxIndex += 1) {
          const allSsrs = paxInfo[paxIndex]?.ssrs;
          tempData[journeyInd][paxInfo[paxIndex]?.passengerKey] = {
            isDomesticExcessBag: false,
            isInternationExcessBag: false,
            isNoExcessBag: true
          };
          for (let ssrInd = 0; ssrInd < allSsrs.length; ssrInd += 1) {
            const currentSsr = allSsrs[ssrInd];
            if (DEMOSTIC_EXCESS_BAGGAGE_KEY.includes(currentSsr.ssrCode)) {
              tempData[journeyInd][paxInfo[paxIndex]?.passengerKey].isDomesticExcessBag = true;
              tempData[journeyInd][paxInfo[paxIndex]?.passengerKey].isNoExcessBag = false;
              if (isNoExcessBagBuy) {
                isNoExcessBagBuy = false;
              }
              if (!isDemesticBagBuy) {
                isDemesticBagBuy = true;
              }
            }
            if (INTERNATION_EXCESS_BAGGAGE_KEY.includes(currentSsr.ssrCode)) {
              tempData[journeyInd][paxInfo[paxIndex]?.passengerKey].isInternationExcessBag = true;
              tempData[journeyInd][paxInfo[paxIndex]?.passengerKey].isNoExcessBag = false;
              if (isNoExcessBagBuy) {
                isNoExcessBagBuy = false;
              }
              if (!isInternationExcessBagBuy) {
                isInternationExcessBagBuy = true;
              }
            }
          }
        }
        journeylevel[journeyInd] = {
          isDomesticExcessBag: isDemesticBagBuy,
          isInternationExcessBag: isInternationExcessBagBuy,
          isNoExcessBag: isNoExcessBagBuy
        };
      }
    }

    response.data = {
      passenger: tempData,
      isNoExcessBagBuy,
      isDemesticBagBuy,
      journeylevel,
      isInternationExcessBagBuy
    };
    return response;
  } catch (error) {
    console.warn(error);
    const response = {
      status: false
    };
    return response;
  }
};

export const getPreviousBuyAddhos = (currentBookinginState: { passengerSegments: string | any[] }, isChangeBooking = false) => {
  try {
    const response = {
      status: true,
      data: {}
    };
    const tempResponse = {};
    if (currentBookinginState?.journeys) {
      for (let journeyInd = 0; journeyInd < currentBookinginState?.journeys.length; journeyInd += 1) {
        const segments = currentBookinginState?.journeys[journeyInd]?.segments;
        const journeyKey = currentBookinginState?.journeys[journeyInd]?.journeyKey;
        tempResponse[journeyKey] = {};
        for (let segInd = 0; segInd < segments.length; segInd += 1) {
          const passengers = segments[segInd]?.passengerSegment;
          tempResponse[segments[segInd]?.segmentKey] = {};
          for (let paxInd = 0; paxInd < passengers.length; paxInd += 1) {
            const paxInfoSsrs = passengers[paxInd]?.ssrs;
            const paxSsrList = {};
            for (let ssrInd = 0; ssrInd < paxInfoSsrs.length; ssrInd += 1) {
              const ssrInfo = paxInfoSsrs[ssrInd];
              if (ssrInfo.isConfirmed) {
                paxSsrList[ssrInfo?.ssrCode] = ssrInfo;
              }
              if (isChangeBooking) {
                let tempSsrInfo = deepCopy(ssrInfo);
                tempSsrInfo.journeyKey = journeyKey
                tempSsrInfo.segmentKey = segments[segInd]?.segmentKey
                paxSsrList[ssrInfo?.ssrCode] = tempSsrInfo;
              }
            }
            tempResponse[journeyKey][passengers[paxInd].passengerKey] = paxSsrList;
            tempResponse[segments[segInd]?.segmentKey][passengers[paxInd].passengerKey] = paxSsrList;
          }
        }
      }
    }

    response.data = tempResponse;
    return response;
  } catch (error) {
    console.warn(error);
    const response = {
      status: false
    };
    return response;
  }
};


export const getBundleAddhons = (currentBookinginState: { passengerSegments: string | any[] }, isChangeBooking = false) => {
  try {
    const response = {
      status: true,
      data: {}
    };
    const tempResponse = {};
    const ssrList = [];
    if (currentBookinginState?.journeys) {
      for (let journeyInd = 0; journeyInd < currentBookinginState?.journeys.length; journeyInd += 1) {
        const segments = currentBookinginState?.journeys[journeyInd]?.segments;
        const journeyKey = currentBookinginState?.journeys[journeyInd]?.journeyKey;
        tempResponse[journeyKey] = {};
        for (let segInd = 0; segInd < segments.length; segInd += 1) {
          const passengers = segments[segInd]?.passengerSegment;
          tempResponse[segments[segInd]?.segmentKey] = {};
          for (let paxInd = 0; paxInd < passengers.length; paxInd += 1) {
            const paxInfoSsrs = passengers[paxInd]?.ssrs;
            const paxSsrList = {};
            for (let ssrInd = 0; ssrInd < paxInfoSsrs.length; ssrInd += 1) {
              const ssrInfo = paxInfoSsrs[ssrInd];
              if (isChangeBooking && ssrInfo.inBundle) {
                let tempSsrInfo = deepCopy(ssrInfo);
                tempSsrInfo.journeyKey = journeyKey
                tempSsrInfo.type = journeyInd === 0 ? 'ONWARD_JOURNEY' : 'RETURN_JOURNEY'
                tempSsrInfo.segmentKey = segments[segInd]?.segmentKey
                paxSsrList[ssrInfo?.ssrCode] = tempSsrInfo;
                ssrList.push(tempSsrInfo);
              }
            }
            tempResponse[journeyKey][passengers[paxInd].passengerKey] = paxSsrList;
            tempResponse[segments[segInd]?.segmentKey][passengers[paxInd].passengerKey] = paxSsrList;
          }
        }
      }
    }
    
    response.data = ssrList;
    return response;
  } catch (error) {
    console.warn(error);
    const response = {
      status: false
    };
    return response;
  }
};

export const checkForEnableSsr = (
  currentBookinginState: { recordLocator?: string | null | undefined } | undefined,
  ssrCode = "PRIO",
  isChangeBooking = false,
  previouslyBroughtSsrs = {},
  ssrData?: { loungeData },
  isSegmentLevel = false
) => {
  try {
    const response = {
      status: true,
      data: {}
    };
    let isDisable = true;
    const currentFeeCode = PNR_LEVEL_SSR_CODES; // trip level or pnr level
    if (isChangeBooking) {
      if (JOURNEY_LEVEL_SSR_CODES.includes(ssrCode) || ssrCode === LOUNGE_SSRCODE || ssrCode === DELAY_COVER_SSRCODE) {
        const isAllPaxSelected = currentBookinginState?.journeys.every(journey => 
          journey?.segments.every(segment => 
            segment?.passengerSegment.every(passenger => 
                passenger?.ssrs?.some(ssr => ssr?.ssrCode === ssrCode && previouslyBroughtSsrs[journey.journeyKey][passenger?.passengerKey][ssrCode]?.journeyKey === journey?.journeyKey)
            )
          )
        );
        response.data.isDisabled = isAllPaxSelected 
      } else if (ssrCode === TRAVEL_INSURANCE_SSRCODE) {
        const isAllPaxSelected = currentBookinginState?.passengers.every(passenger => 
          passenger?.fees.some(fee => {
            if (fee?.code === TRAVEL_INSURANCE_SSRCODE) {
              return true
            }
          })
        );        
        response.data.isDisabled = isAllPaxSelected 
      } else if (ssrCode === DELAY_AND_LOST_BAGGAGE_SSRCODE) {
        const isAllPaxSelected = currentBookinginState?.passengers.every(passenger => 
          passenger?.fees.some(fee => {
            if (fee?.code === DELAY_AND_LOST_BAGGAGE_SSRCODE) {
              return true
            }
          })
        );        
        response.data.isDisabled = isAllPaxSelected 
      }
    } else {
      if (currentFeeCode.includes(ssrCode)) {
        if (currentBookinginState?.passengers) {
          for (let index = 0; index < currentBookinginState?.passengers.length; index += 1) {
            const SsrList = currentBookinginState?.passengers[index]?.fees;
            const isFound = SsrList.filter((ssr: { code: string }) => ssr.code === ssrCode);
            if (isFound.length === 0) {
              isDisable = false;
              break;
            }
          }
        }
        response.data.isDisabled = isDisable;
      } else if (currentBookinginState?.journeys) {
        for (let journeyInd = 0; journeyInd < currentBookinginState?.journeys.length; journeyInd += 1) {
          const journeyInfo = currentBookinginState?.journeys[journeyInd];
  
          let allPaxs = journeyInfo?.segments[0]?.passengerSegment;
          let segmentKey = journeyInfo?.segments[0]?.segmentKey;
          const journeyKey = journeyInfo?.journeyKey;
          if (isSegmentLevel) {
            for (const segmentInfo of journeyInfo.segments) {
              segmentKey = segmentInfo.segmentKey;
              allPaxs = segmentInfo.passengerSegment;
              for (let paxInd = 0; paxInd < allPaxs.length; paxInd += 1) {
                const paxInfo = allPaxs[paxInd];
                const buySsrs = paxInfo?.ssrs;
                const isFound = buySsrs.filter(
                  (item: { ssrCode: string; isConfirmed: boolean }) =>
                    item.ssrCode === ssrCode && item.isConfirmed === true
                );
                // if ssr is not found, means, user havent buy it, and can buy it, so dont disable
                // if its not buy by even one user, enable it
                // before disable check weather the current jourey is applicatible for the current ssr;
                // check for the timelimit of ssr code and duration f
                let checkForDisabledWithTime = true;
                if (LOUNGE_SSRCODE === ssrCode) {
                  // for now added only for LOUNGE_SSRCODE, tomow we can extend this for all
                  const hourLeftForDeparture = moment
                    .duration(
                      moment(currentBookinginState.journeys?.[journeyInd].designator?.departure).diff(moment.now())
                    )
                    .asHours();
                  checkForDisabledWithTime = checkForSsrDisabled(ssrCode, hourLeftForDeparture, currentBookinginState);
                  if (ssrData.loungeData) {
                    const checkForSsrEnableOrNot = Object.entries(ssrData.loungeData).find(
                      ([, value]) => value.key === segmentKey
                    );
                    if (!checkForSsrEnableOrNot) {
                      checkForDisabledWithTime = false;
                    }
                  }
                }
                if (isFound.length === 0 && checkForDisabledWithTime) {
                  isDisable = false;
                  break;
                }
              }
            }
          } else {
            for (let paxInd = 0; paxInd < allPaxs.length; paxInd += 1) {
              const paxInfo = allPaxs[paxInd];
              const buySsrs = paxInfo?.ssrs;
              const isFound = buySsrs.filter(
                (item: { ssrCode: string; isConfirmed: boolean }) => item.ssrCode === ssrCode && item.isConfirmed === true
              );
              // if ssr is not found, means, user havent buy it, and can buy it, so dont disable
              // if its not buy by even one user, enable it
              // before disable check weather the current jourey is applicatible for the current ssr;
              // check for the timelimit of ssr code and duration f
              let checkForDisabledWithTime = true;
              if (LOUNGE_SSRCODE === ssrCode) {
                // for now added only for LOUNGE_SSRCODE, tomow we can extend this for all
                const hourLeftForDeparture = moment
                  .duration(moment(currentBookinginState.journeys?.[journeyInd].designator?.departure).diff(moment.now()))
                  .asHours();
                checkForDisabledWithTime = checkForSsrDisabled(ssrCode, hourLeftForDeparture, currentBookinginState);
                if (ssrData.loungeData) {
                  const checkForSsrEnableOrNot = Object.entries(ssrData.loungeData).find(
                    ([, value]) => value.key === segmentKey
                  );
                  if (!checkForSsrEnableOrNot) {
                    checkForDisabledWithTime = false;
                  }
                }
              }
              if (isFound.length === 0 && checkForDisabledWithTime) {
                isDisable = false;
                break;
              }
            }
          }
        }
        response.data.isDisabled = isDisable;
      }
    }

    return response;
  } catch (error) {
    console.warn(error);
    const response = {
      status: false
    };
    return response;
  }
};

export function checkAnySegmentHasSeatSelected(segments: Segment[]): boolean {
  return segments.some((segment: Segment) => segment?.passengerSegment?.some((passengerSegment: PassengerSegmentValue) => passengerSegment?.seats?.length > 0));
}

export function checkAllJourneysHaveSeat(currentBookinginState: Booking): boolean {
  return currentBookinginState?.journeys?.every((journey: Journey) => checkAnySegmentHasSeatSelected(journey?.segments));  
}

// deprecated function
export function checkSeatAndMealDisabled(currentBookinginState: any, bookingInRedux: any): boolean {
  let seatAndMealJourneys: any = [];
  currentBookinginState?.journeys?.forEach((journey: any) => {
    const isSeatAndMealDealAdded = bookingInRedux?.runningAddhons[BUNDLE_CODE.SEAT_PLUS_MEAL]?.journeyKeys?.some((key) => key === journey?.journeyKey) || false;
    if (isSeatAndMealDealAdded || journey?.segments?.[0]?.passengerSegment?.[0]?.ssrs.length < 1)
      seatAndMealJourneys = [...seatAndMealJourneys, journey];
  });

  return (seatAndMealJourneys.length < 1);
}

export const isConnectingFlight = (currentBookinginState: { journeys: any[] }) => {
  if (currentBookinginState?.journeys && currentBookinginState?.journeys[0]?.segments) {
    return !!(currentBookinginState?.journeys && currentBookinginState?.journeys[0]?.segments.length > 1);
  }
  return true;
};
/*
this card will return true / false, if the card is enable to display in ssr list
*/
export const displaySsrCard = (
  currentBookinginState: { recordLocator?: string | null | undefined; journeys: any[]; passengers: any[] } | undefined,
  ssrCode = "PRIO",
  isInternationalFlight: boolean,
  isAutoAssign: boolean,
  cardCode: string,
  ssrData: { loungeData?: any; flexiCoverData: any; flightDelayCover: any; seatAndMealDeal: any },
) => {
  
  const { webConfig }: any = useCommonContext();
  const showSeatAndMealBundle = webConfig?.showSeatAndMealBundle ?? false;
  const isGroupBooking = (currentBookinginState?.isGroupBooking === true) ? true : false;
  const isRestrictSeatMealPaxCount =(currentBookinginState?.passengers?.length > 9) ? true : false;

  const isExtraSeatAvailable = currentBookinginState?.extraSeatPassengers?.length > 0 ?? false

  let bundleJourneys: any = [];
  currentBookinginState?.journeys?.forEach((journey: any) => {
    if (!journey?.segments?.[0]?.passengerSegment?.[0]?.ssrs?.some((ssr) => ssr.ssrCode !== BUNDLE_CODE.SEAT_PLUS_MEAL && ssr.inBundle)) {
      bundleJourneys = [...bundleJourneys, journey];
    }
  });


  let mealsMeal = false;

  if (cardCode === MEALS_MEAL_CODE) {
    mealsMeal = currentBookinginState?.journeys?.every((journey: any) => {
      const duration = moment.duration(moment(journey?.designator?.departure).diff(moment.now())).asHours();
      return Math.floor(duration) <= MEAL_BOOKING_HOUR_LIMIT; // Return true if duration is more than 12 hours
    }) || false; // Ensure mealsMeal is false if journeys is undefined or empty
  }

  const isPlusBundle = (bundleJourneys.length < 1);
  const hideTripCover = currentBookinginState?.passengers?.some(p => p?.passengerTypeCode === "SNR")

  try {
    let response = true;
    if (ssrCode === LOUNGE_SSRCODE && Object.keys(ssrData.loungeData).length === 0) {
      return false;
    }
    if (ssrCode === CANCEL_COVER_SSRCODE && Object.keys(ssrData.flexiCoverData).length === 0) {
      return false;
    }
    if (ssrCode === DELAY_COVER_SSRCODE && Object.keys(ssrData.flightDelayCover).length === 0) {
      return false;
    }
    if (ssrCode === BUNDLE_CODE.SEAT_PLUS_MEAL && (Object.keys(ssrData.seatAndMealDeal).length <= 0 || !showSeatAndMealBundle || isExtraSeatAvailable || isPlusBundle || isAutoAssign || isRestrictSeatMealPaxCount || isGroupBooking || checkAllJourneysHaveSeat(currentBookinginState))) {
      return false;
    }
    if (ssrCode === TRAVEL_INSURANCE_SSRCODE && (isInternationalFlight || isExtraSeatAvailable || isGroupBooking || hideTripCover)) {
      return false;
    }
    if (ssrCode === DELAY_AND_LOST_BAGGAGE_SSRCODE && (isExtraSeatAvailable || isGroupBooking)) {
      return false;
    }
    if (cardCode === MEALS_MEAL_CODE && mealsMeal) {
      return false;
    }

   
    if (currentBookinginState?.journeys) {
      for (let journeyInd = 0; journeyInd < currentBookinginState?.journeys.length; journeyInd += 1) {
        const journeyInfo = currentBookinginState?.journeys[journeyInd];
        response = true;
        const hourLeftForDeparture = moment
          .duration(moment(journeyInfo.designator?.departure).diff(moment.now()))
          .asHours();
        response = checkForSsrDisabled(ssrCode, hourLeftForDeparture, currentBookinginState);
        if (ssrCode === LOUNGE_SSRCODE && response) {
          const selectedSegmentInfo = JSON.parse(localStorage.getItem("segmentDetails"));
          if (selectedSegmentInfo) {
            const checkForLeg = selectedSegmentInfo.filter((seg: { key: any }) =>
              journeyInfo.segments.some((segment: { segmentKey: any }) => segment.segmentKey === seg.key)
            );
            if (checkForLeg && checkForLeg.length === 0) {
              response = false;
            }
          }
        }
      }
    }

    return response;
  } catch (error) {
    console.error(error);
    return true;
  }
};


export const displayRemoveAllSSRIcon = (
  isChangeBooking: boolean = false,
  currentBookinginState: { recordLocator?: string | null | undefined; journeys: any[] } | undefined,
  cardCode = "",
  previouslyBroughtSsrs?: any
) => {
  if (isChangeBooking) {
    let newSsr = false;

    if (cardCode === EXCESS_BAGGAGE_CODE) {
      currentBookinginState?.journeys.forEach(journey => {
        journey.segments.forEach(segment => {
          segment.passengerSegment.forEach(passenger => {
            passenger.ssrs.forEach(ssr => {
              if (
                previouslyBroughtSsrs[journey.journeyKey] && 
                previouslyBroughtSsrs[journey.journeyKey][passenger?.passengerKey][ssr.ssrCode] && 
                previouslyBroughtSsrs[journey.journeyKey][passenger?.passengerKey][ssr.ssrCode].journeyKey === journey.journeyKey
              ) {
              } else {
                if (ALL_BAGGAGE_SSRCODES.includes(ssr.ssrCode))
                newSsr = true;
                return;
              }
            });
            if (newSsr) return;
          });
          if (newSsr) return;
        });
        if (newSsr) return;
      });
    } else if (cardCode === MEALS_MEAL_CODE) {
      let soldSsrs: any = JSON.parse(localStorage.getItem("addedSsrKey") as string);

      let reselledSsrs: any = JSON.parse(localStorage.getItem("reselledSsrKey") as string) || [];
      if (soldSsrs.length > reselledSsrs.length) {
        newSsr = true;
        return newSsr;
      } else {
        for (let soldSsr of soldSsrs) {
          const tempReselledSsr = reselledSsrs.find((reselledSsr: any) => 
            soldSsr.passKey === reselledSsr.passKey &&
            soldSsr.segmentKey === reselledSsr.segmentKey && 
            soldSsr.ssrCode === reselledSsr.ssrCode
          );
          if (tempReselledSsr && soldSsr.count > tempReselledSsr.count) {
            newSsr = true;
            return newSsr;
          }
        }
      }
    } else if (cardCode === PRIORITY_BAGGAGE_SSRCODE || 
      cardCode === PRIORITY_BOARDING_SSRCODE) {
        currentBookinginState?.journeys.forEach(journey => {
          journey.segments.forEach(segment => {
            segment.passengerSegment.forEach(passenger => {
              passenger.ssrs.forEach(ssr => {
                if (
                  
                  previouslyBroughtSsrs[journey.journeyKey] && 
                  previouslyBroughtSsrs[journey.journeyKey][passenger?.passengerKey][ssr.ssrCode] && 
                  previouslyBroughtSsrs[journey.journeyKey][passenger?.passengerKey][ssr.ssrCode].journeyKey === journey.journeyKey
                ) {
                } else {
                  if (ssr.ssrCode === cardCode) {
                    newSsr = true;
                    return;
                  }
                }
              });
              if (newSsr) return;
            });
            if (newSsr) return;
          });
          if (newSsr) return;
        });
    } else if (cardCode === LOUNGE_SSRCODE || 
      cardCode === DELAY_COVER_SSRCODE) {
        currentBookinginState?.journeys.forEach(journey => {
          journey.segments.forEach(segment => {
            segment.passengerSegment.forEach(passenger => {
              passenger.ssrs.forEach(ssr => {
                if (
                  previouslyBroughtSsrs[segment.segmentKey] && 
                  previouslyBroughtSsrs[segment.segmentKey][passenger?.passengerKey][ssr.ssrCode] && 
                  previouslyBroughtSsrs[segment.segmentKey][passenger?.passengerKey][ssr.ssrCode].segmentKey === segment.segmentKey
                ) {
                } else {
                  if (ssr.ssrCode === cardCode) {
                    newSsr = true;
                    return;
                  }
                }
              });
              if (newSsr) return;
            });
            if (newSsr) return;
          });
          if (newSsr) return;
        });
    } else if (cardCode === TRAVEL_INSURANCE_SSRCODE || 
      cardCode === DELAY_AND_LOST_BAGGAGE_SSRCODE) {
      const containsCardCode = currentBookinginState?.passengers.some(passenger => 
        passenger.fees.some(fee => fee.code === cardCode)
      ); 
      newSsr = !containsCardCode
    }
    return newSsr;
  }
  return !isChangeBooking;
};


/* for trip cover, we need to set the date of birth of the user to navitor */

export async function setupDateOfBirthOfUser(
  currentBookingInState: { passengers: any[] },
  userTripInfo: { [x: string]: { dateOfBirth: moment.MomentInput } }
) {
  try {
    const tempPaxInfo: {
      info: { gender: any; dateOfBirth: any };
      name: { first: any; last: any };
      passengerKey: string;
    }[] = [];
    const userInfoFromBooking = {};
    currentBookingInState?.passengers.forEach((passenger: { passengerKey: string | number }) => {
      userInfoFromBooking[passenger.passengerKey] = passenger;
    });

    Object.keys(userTripInfo).forEach((key) => {
      const paxInfo = deepCopy(userInfoFromBooking[key]);
      paxInfo.info.dateOfBirth = moment(userTripInfo[key]?.dateOfBirth).format("YYYY-MM-DD");
      tempPaxInfo.push({
        info: {
          gender: paxInfo.info.gender,
          dateOfBirth: paxInfo.info.dateOfBirth
        },
        name: {
          first: paxInfo.name.first,
          last: paxInfo.name.last
        },
        passengerKey: key
      });
    });

    const dataResponse = await addDateOfBirth({ passengers: tempPaxInfo });
    return dataResponse;
  } catch (error) {
    console.warn(error);
  }
}

/* for trip cover, get the price from navitor */

export async function getFeesPrice(currentBookingInState: { passengers: any[] }, FEE_CODE: any) {
  try {
    if (currentBookingInState && currentBookingInState?.passengers) {
      const data = {
        feeCode: FEE_CODE
      };
      currentBookingInState?.passengers.forEach((passenger: { passengerKey: any }) => {
        data.paxKey = passenger?.passengerKey;
      });

      const dataResponse = await getFeeCodesPrice(data);
      return dataResponse;
    }
    return false;
  } catch (error) {
    console.warn(error);
    return false;
  }
}

//

/* if we have something that is in local variables, 
and need to buy on before payment done, we can synup in the below function */

export async function checkForSyncup(
  currentBookingInRedux: { currentBookingInState: any; runningAddhons: { [x: string]: { isActive: boolean } } },
  dispatch: Dispatch<AnyAction> | null | undefined = null
) {
  try {
    const response = {
      status: true
    };

    // check wheather we have to sell the travel insurnace again or not :

    // isUserAlreadyBuyTravelInsu.data.isDisabled should be false, if user have not buy it,
    const avaliableFeeCodes = FEE_CODES;
    for (let feeCodeInd = 0; feeCodeInd < avaliableFeeCodes.length; feeCodeInd += 1) {
      const feeCode = avaliableFeeCodes[feeCodeInd];
      const isUserAlreadyBuyTravelInsu = checkForEnableSsr(currentBookingInRedux.currentBookingInState, feeCode);
      if (
        currentBookingInRedux?.runningAddhons &&
        currentBookingInRedux?.runningAddhons[feeCode] &&
        currentBookingInRedux?.runningAddhons[feeCode]?.isActive === true &&
        isUserAlreadyBuyTravelInsu.data.isDisabled === false
      ) {
        await sellTripCover(feeCode);
        const currentState = await CurrentBookingInState();
        if (dispatch) {
          dispatch(setCurrentBookingInState({currentBookingInState: currentState?.data?.data}));
        }
      }
    }

    if (dispatch) {
      // reset the priceDiff ; disable the active of sell ssr,
      dispatch(resetPriceDiff());
    }
    return response;
  } catch (error) {
    console.warn(error);
    return false;
  }
}



export async function changeBookingUpdatedSSR(currentBookingInState: any) {
  try {
    const response = await getMealsList();
    let mealsSSRList = [];
    if (response) {
      const { story } = response;
      mealsSSRList = story?.content?.body.map(meal => meal?.ssrCode);
    }
    // TRAVEL_INSURANCE_SSRCODE
    let soldSsrs: any = [];
    if (currentBookingInState && currentBookingInState.journeys) {
      currentBookingInState.journeys.forEach((journey) => {
        journey.segments.forEach((segment) => {
          segment.passengerSegment.forEach((ps) => {
            ps.ssrs.forEach((ssr) => {  
              if ([...ALL_BAGGAGE_SSRCODES, ...mealsSSRList, PRIORITY_BAGGAGE_SSRCODE,
                PRIORITY_BOARDING_SSRCODE,
                LOUNGE_SSRCODE, DELAY_COVER_SSRCODE].includes(ssr.ssrCode) && !ssr?.inBundle) {
                if (isJourneyLevelSsr(ssr.ssrCode)) {
                  const result = soldSsrs.some((soldssr) => soldssr.ssrCode === ssr.ssrCode &&
                  soldssr.passengerKey === ssr.passengerKey &&
                  soldssr.journeyKey === journey.journeyKey
                  )                 
                    if (!result) {
                    const toBeAddedSSR = {
                      count: 1,
                      ssrKey: ssr.ssrKey,
                      segmentKey: segment.segmentKey,
                      passengerKey: ssr.passengerKey,
                      ssrCode: ssr.ssrCode,
                      journeyKey: journey.journeyKey,
                      legKey: segment?.legs[0]?.legKey,
                      duplicateSsr: false
                    }
                    soldSsrs = [...soldSsrs, toBeAddedSSR]
                    } else {
                      const alreadyExistSSR = {
                        count: 1,
                        ssrKey: ssr.ssrKey,
                        segmentKey: segment.segmentKey,
                        passengerKey: ssr.passengerKey,
                        ssrCode: ssr.ssrCode,
                        journeyKey: journey.journeyKey,
                        legKey: segment?.legs[0]?.legKey,
                        duplicateSsr: true
                      }
                      soldSsrs = [...soldSsrs, alreadyExistSSR]
                    }  
                } else {
                  const toBeAddedSSR = {
                    count: 1,
                    ssrKey: ssr.ssrKey,
                    segmentKey: segment.segmentKey,
                    passengerKey: ssr.passengerKey,
                    ssrCode: ssr.ssrCode,
                    journeyKey: journey.journeyKey,
                    legKey: segment?.legs[0]?.legKey,
                    duplicateSsr: false
                  }
                  soldSsrs = [...soldSsrs, toBeAddedSSR]
                }
              }    
            });
          });
        });
      });
      currentBookingInState.passengers.forEach((pax) => {
        const ssrs = pax.fees.filter((fee) => fee.code === DELAY_AND_LOST_BAGGAGE_SSRCODE || fee.code === TRAVEL_INSURANCE_SSRCODE)
        ssrs.forEach(ssr => {
          const toBeAddedSSR = {
            count: 1,
            passengerKey: pax.passengerKey,
            ssrCode: ssr.code
          }
          soldSsrs = [...soldSsrs, toBeAddedSSR]
        });
      });
    }
    return soldSsrs;
  } catch (error) {
    console.warn(error);
    return [];
  }
}